import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class vistar
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.vistar = {};

/**
 * Gets api key and networkId for the Vistar widget
 * @param {ReachAPI.Security} security
 * @param {number} widgetId
 * @throws {ReachApiError}
 * @returns {Promise<ReachApiResponse>}
 * @memberof ReachAPI.vistar
 */
ReachAPI.vistar.getCredentials = function (security, widgetId) {
    var url = ReachAPI.server + '/signage/vistar/credentials/' + widgetId;
    var params = {};
    var jqPromise;

    if (security.token) {
        params.token = security.token;
    } else {
        params.uuid = security.player_uuid;
    }
    jqPromise = ReachAPI.get(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Info('Placeholder.', null, __fileline);
        } else {
            Log.Debug('Retrieved account data from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Vistar account data',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return ReachAPI.deferredToPromise(jqPromise);
};
